import React, { useEffect, useMemo, useState } from "react";
import { MDBSwitch } from "mdbreact";

import "./NotificationSettings.scss";

import { Label, SIZING, Button } from "abs-ui-components";

import BreadCrumb from "../../common/breadCrumb/BreadCrumb";
import {
	ACCOUNT_NAV_ID,
	ACCOUNT_NAV_TEXT,
	NOTIFICATION_NAV_ID,
	NOTIFICATION_NAV_TEXT,
} from "./NotificationSettingsConstant";
import CustomTable from "../../common/customTable/CustomTable";
import { accessAPIForResponse } from "../../services/api-services/api-implementations";
import axiosHttp from "../../services/interceptor";
import { emitToasterMsg } from "../../services/toasterUtility";
import { formatNotificationTemplateName } from "../../services/utilities";
import { useSelector } from "react-redux";

const NotificationSettings = () => {
	const [notificationsData, setNotificationsData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [initialSwitchState, setInitialSwitchState] = useState({});
	const [isChanged, setIsChanged] = useState(false);
	const [switchState, setSwitchState] = useState({});
	const [verifyStatus, setVerifyStatus] = useState();

	const breadcrumb = useMemo(
		() => [
			{
				label: ACCOUNT_NAV_TEXT,
				url: "",
				navId: ACCOUNT_NAV_ID,
			},
			{
				label: NOTIFICATION_NAV_TEXT,
				url: "",
				navId: NOTIFICATION_NAV_ID,
			},
		],
		[]
	);

	const userData = useSelector((state) => state.userInfo.userData);

	const NOTIFICATION_ORDER = [
		"USER_CREATES_A_VESSEL",
		"USER_MODIFIES_THE_DATA_OF_A_VESSEL",
		"USER_CREATES_A_REPORT",
		"USER_MODIFIES_THE_DATA_OF_A_REPORT",
		"USER_DELETES_A_REPORT",
		"USER_SUBMITS_A_REPORT_TO_ABS",
		"USER_1_ASSIGNS_A_REPORT_TO_USER_2_FOR_REVIEW",
		"AIS_CALCULATION_FAILED",
		"USER_SUBMITS_SUPPORTING_DOCUMENTS_TO_ABS",
		"USER_CREATES_A_CORRECTION_REQUEST",
		"USER_REPLIES_TO_A_CORRECTION_REQUEST",
		"USER_CLOSES_A_CORRECTION_REQUEST",
		"USER_1_ASSIGNS_A_REPORT_TO_USER_2_FOR_VERIFICATION",
		"USER_MARKS_THE_REPORT_AS_VERIFICATION_COMPLETE"
	];

	const sortNotifications = (data) => {
		return data.sort((a, b) => {
			const indexA = NOTIFICATION_ORDER.indexOf(a.name);
			const indexB = NOTIFICATION_ORDER.indexOf(b.name);
			
			if (indexA !== -1 && indexB !== -1) {
				return indexA - indexB;
			}

			if (indexA !== -1) return -1;

			if (indexB !== -1) return 1;

			return 0;
		});
	};

	const NOTIFICATION_HEADER_COLUMNS = [
		{
			header: "Notification Name",
			accessorFn: (row) => formatNotificationTemplateName(row.name),
			enableSorting: false,
		},
		{
			header: "Active",
			accessorKey: "isSubscribed",
			enableSorting: false,
			accessorFn: (row) => {
				return (
					<div>
						<MDBSwitch
							id={`switch-${row.templateMstId}-${
								switchState[row.templateMstId]
							}`}
							checked={switchState[row.templateMstId]}
							onChange={() =>
								handleSwitchChange(row.templateMstId)
							}
							labelLeft=""
							labelRight=""
						/>
					</div>
				);
			},
		},
	];
	useEffect(() => {
		if (verifyStatus !== undefined) {
		}
	}, [verifyStatus]);
	const getNotificationSettingsData = async () => {
		setLoading(true);
		await accessAPIForResponse("GetNotifications", null, [])
			.then((response) => {
				
				if (response && response?.data) {
					
					const initialState =
						response?.data &&
						response?.data?.reduce(
							(acc, item) => ({
								...acc,
								[item.templateMstId]: item.isSubscribed,
							}),
							{}
						);
						
					setInitialSwitchState(initialState);
					setSwitchState(initialState);
					let roles = [];
					try {
						if (userData) {
							const parsedUserData = typeof userData === 'string' ? JSON.parse(userData) : userData;
							roles = parsedUserData?.roles || [];
						}
					} catch (error) {
						console.error("Error parsing userData:", error);
						roles = [];
					}
					let filteredNotificationsdata = response.data.slice(0, -1);
					if (roles.includes("ER_CLIENT")) {
						filteredNotificationsdata =
							filteredNotificationsdata.filter(
								(item) =>
									![
										"AIS_CALCULATION_FAILED",
										"USER_1_ASSIGNS_A_REPORT_TO_USER_2_FOR_REVIEW",
										"USER_1_ASSIGNS_A_REPORT_TO_USER_2_FOR_VERIFICATION",
										"USER_MAKES_PARENT_REPORT_AMENDMENT",
										"USER_SUBMITS_SUPPORTING_DOCUMENTS_TO_ABS"
									].includes(item.name)
							);
					} else  {
						filteredNotificationsdata =
							filteredNotificationsdata.filter(
								(item) =>
									![
										"USER_CREATES_A_VESSEL",
										"USER_CREATES_A_REPORT",
										"USER_MODIFIES_THE_DATA_OF_A_VESSEL",
										"USER_MAKES_PARENT_REPORT_AMENDMENT",
										"USER_SUBMITS_SUPPORTING_DOCUMENTS_TO_ABS"
									].includes(item.name)
							);
					}
					
					const sortedNotifications = sortNotifications(filteredNotificationsdata);
					setNotificationsData(sortedNotifications);
				} else {
					setNotificationsData([]);
				}
				setLoading(false);
			})
			.catch((error) => {
				console.error("Error fetching notifications:", error);
				setNotificationsData([]);
				setLoading(false);
			});
	};

	const handleEmailConfirm = async () => {
		try {
			const response = await axiosHttp.get(
				`api/Accounts/SendConfirmEmail`
			);

			if (response.status === 200) {
				emitToasterMsg(
					"success",

					"Notifications",

					"Email sent successfully"
				);
			} else {
				emitToasterMsg(
					"error",

					"Notifications",

					"Failed to send email. Please try again."
				);
			}
		} catch (error) {
			console.error("Error occurred during email confirmation:", error);
		}
	};

	const handleVerifyEmail = async () => {
		await accessAPIForResponse("verifyEmail", null, []).then((response) => {
			setVerifyStatus(response);
		});
	};

	useEffect(() => {
		getNotificationSettingsData();
		handleVerifyEmail();
	}, []);

	const handleSwitchChange = (id) => {
		setSwitchState((prevState) => ({
			...prevState,
			[id]: !prevState[id],
		}));

		// Update the main notificationsData state to reflect the change
		setNotificationsData((prevData) =>
			prevData.map((item) =>
				item.templateMstId === id
					? { ...item, isSubscribed: !item.isSubscribed }
					: item
			)
		);
	};

	useEffect(() => {
		if (
			JSON.stringify(switchState) !== JSON.stringify(initialSwitchState)
		) {
			setIsChanged(true);
		} else {
			setIsChanged(false);
		}
	}, [switchState, initialSwitchState]);

	const handleSave = () => {
		// Prepare the payload

		const payload = notificationsData.map((item) => ({
			templateMstId: item.templateMstId,
			Name: item.name,
			IsSubscribed: item.isSubscribed,
		}));

		setLoading(true);
		axiosHttp({
			url: `api/Notifications/SetNotification`,
			method: "POST",
			data: payload,
		})
			.then((res) => {
				setLoading(false);
				if (res.status === 200) {
					emitToasterMsg(
						"success",
						"Notifications",
						"Notifications updated Successfully"
					);
					setInitialSwitchState(switchState);
					setIsChanged(false);
				}
			})
			.catch((error) => {
				setLoading(false);
				console.error(error);
			});
	};

	return (
		<>
			<div className="notifications-container d-flex justify-content-between">
				<BreadCrumb items={breadcrumb} />
				{!verifyStatus && (
					<div className="d-flex">
						<h6 className="verify-email pt-2 ms-2">
							{" "}
							Verify your Email:{" "}
						</h6>

						<>
							<Button
								onClick={handleEmailConfirm}
								disabled={verifyStatus}
							>
								{" "}
								Verify
							</Button>
						</>
					</div>
				)}
			</div>

			<div className="notifications-container custom-tb-cont">
				{notificationsData && (
					<>
						<div
							style={{
								display: "flex",
								justifyContent: "space-between",
								padding: "9px",
							}}
						>
							<Label
								name="Notification Settings"
								size={SIZING.XLARGE}
								bold={true}
							></Label>

							{notificationsData.length > 0 && (
								<>
									<button
										type="submit"
										className={`save-button ${
											isChanged ? "" : "disabled-button"
										}`}
										onClick={handleSave}
										disabled={!isChanged}
									>
										Save
									</button>
								</>
							)}
						</div>
						<CustomTable
							renderTableData={notificationsData}
							columnsData={NOTIFICATION_HEADER_COLUMNS}
							customProps={{
								isLoading: loading,
								columnOrder: ["Notification Name", "Active"],
								enableToptoolbar: false,
							}}
						/>
					</>
				)}
			</div>
		</>
	);
};

export default NotificationSettings;
